import React from "react"
import Grid from '@mui/material/Grid'
import SimpleTextField from "../../../../../components/Forms/SimpleTextField"

const CapRefill = ({ value, onChange }) => (
    <Grid item xs={12} md={6} lg={4} xl={3}>
      <SimpleTextField
        value={value}
        onChange={onChange}
        label="Capillary Refill Time"
        type="number"
        InputProps={{
          inputProps: { min: 0, max: 30, step: 'any' },
          endAdornment: 'sec',
        }}
      />
    </Grid>
  )

  export default CapRefill
